if (!customElements.get("product-recommendations")) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initializeRecommendations();
    }

    initializeRecommendations() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) {
          return;
        }

        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => {
            if (!response.ok) throw new Error("Unable to load product recommendations.");
            return response.text();
          })
          .then((text) => {
            const html = document.createElement("div");
            html.innerHTML = text;
            const recommendations = [...html.querySelectorAll("product-recommendations")].find((node) => node.id === this.id) || html.querySelector("product-recommendations");

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector(".card")) {
              this.classList.add("product-recommendations-loaded");
            }
            if (this.hasAttribute("data-product-nav-target")) {
              this.dataset.productNavState = recommendations?.dataset.productNavState || "empty";
              if (this.dataset.productNavState !== "ready") this.replaceChildren();
            }
          })
          .catch((error) => {
            if (this.hasAttribute("data-product-nav-target")) {
              this.dataset.productNavState = "error";
              this.replaceChildren();
            }
            console.error(error);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: "0px 0px 200px 0px",
      }).observe(this);
    }
  }

  customElements.define("product-recommendations", ProductRecommendations);
}
